import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf01ae04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-lg-400px w-xl-400px mb-10 mb-lg-0 event-list-container" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-body p-0" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_9 = {
  key: 2,
  class: "event-list-scroll"
}
const _hoisted_10 = { class: "table table-hover align-middle gs-0 gy-3" }
const _hoisted_11 = { class: "sticky-header" }
const _hoisted_12 = { class: "text-start text-muted fw-bold fs-7 text-uppercase" }
const _hoisted_13 = { class: "ps-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "ps-4" }
const _hoisted_16 = { class: "text-dark fw-semibold d-block fs-6" }
const _hoisted_17 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-header" }
const _hoisted_20 = { class: "card-title" }
const _hoisted_21 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_22 = { class: "d-flex align-items-center gap-2" }
const _hoisted_23 = { class: "position-relative" }
const _hoisted_24 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "card-body p-0" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_30 = {
  key: 1,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_31 = {
  key: 2,
  class: "participant-list-scroll"
}
const _hoisted_32 = { class: "table table-tenant-sm table-hover" }
const _hoisted_33 = { class: "sticky-header" }
const _hoisted_34 = { class: "text-start text-muted fw-bold fs-7 text-uppercase" }
const _hoisted_35 = { class: "ps-5" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "ps-5" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "d-flex justify-content-center gap-2" }
const _hoisted_40 = { class: "px-5 py-3" }

import { ref, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataCentralBox from "@/components/NoDataCentralBox.vue";
import UserInfo from "@/components/UserInfo.vue";
import TimeShow from "@/components/TimeShow.vue";
import HeaderMenu from "../../Payment/components/HeaderMenu.vue";
import TableFooter from "@/components/TableFooter.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventsServices from "../services/EventsServices";

interface Event {
  id: number;
  title: string;
  key: string;
}

interface ParticipantUser {
  partyId: number;
  firstName: string;
  lastName: string;
  email: string;
  avatar?: string;
}

interface Participant {
  id: number;
  user: ParticipantUser;
  status: number;
  createdOn: string;
  operatorName: string;
}

// Participant Status Types - matching API enum

export default /*#__PURE__*/_defineComponent({
  __name: 'EventPartyIndex',
  setup(__props) {

const { t } = useI18n();

const ParticipantStatusType = {
  Pending: 1, // Applied
  Completed: 2, // Approved
  Rejected: 3,
  Canceled: 4, // Cancelled
  All: 5,
};

const isLoading = ref(false);
const isLoadingParticipants = ref(false);
const events = ref<Event[]>([]);
const selectedEvent = ref<Event | null>(null);
const selectedEventId = ref<number | null>(null);
const participants = ref<Participant[]>([]);
const searchQuery = ref("");
const participantSearchInput = ref<HTMLInputElement | null>(null);
const headerMenuRef = ref<InstanceType<typeof HeaderMenu>>();
const currentTab = ref(ParticipantStatusType.Pending);
const criteria = ref<any>({
  page: 1,
  pageSize: 25,
  eventId: null,
  status: ParticipantStatusType.Pending,
});

// Get tag type based on status
const getTagType = (status: number): string => {
  switch (status) {
    case ParticipantStatusType.Pending:
      return "warning";
    case ParticipantStatusType.Completed:
      return "success";
    case ParticipantStatusType.Rejected:
      return "danger";
    case ParticipantStatusType.Canceled:
      return "info";
    default:
      return "primary";
  }
};

// Get status label
const getStatusLabel = (status: number): string => {
  switch (status) {
    case ParticipantStatusType.Pending:
      return "pending";
    case ParticipantStatusType.Completed:
      return "completed";
    case ParticipantStatusType.Rejected:
      return "rejected";
    case ParticipantStatusType.Canceled:
      return "canceled";
    default:
      return "unknown";
  }
};

// Get action buttons based on status
const getActionButtons = (participant: Participant) => {
  const buttons: Array<{ label: string; type: string; action: () => void }> =
    [];

  switch (participant.status) {
    case ParticipantStatusType.Pending:
      buttons.push({
        label: t("action.approve"),
        type: "primary",
        action: () => handleApprove(participant.id),
      });
      buttons.push({
        label: t("action.reject"),
        type: "danger",
        action: () => handleReject(participant.id),
      });
      break;
    case ParticipantStatusType.Rejected:
    case ParticipantStatusType.Canceled:
      buttons.push({
        label: t("action.restore"),
        type: "warning",
        action: () => handleRestore(participant.id),
      });
      break;
  }

  return buttons;
};

// Action handlers (to be connected with real API)
const handleApprove = async (id: number) => {
  try {
    await EventsServices.approveEventApplication(id);
    await fetchParticipants(criteria.value.page);
  } catch (error) {
    console.error("Error approving participant:", error);
    MsgPrompt.error("Failed to approve participant");
  }
};

const handleReject = async (id: number) => {
  try {
    await EventsServices.rejectEventApplication(id);
    await fetchParticipants(criteria.value.page);
  } catch (error) {
    console.error("Error rejecting participant:", error);
    MsgPrompt.error("Failed to reject participant");
  }
};

const handleRestore = async (id: number) => {
  try {
    await EventsServices.revertEventApplication(id);
    // Do not show a success toast after restore per UX requirement
    await fetchParticipants(criteria.value.page);
  } catch (error) {
    console.error("Error restoring participant:", error);
    MsgPrompt.error("Failed to restore participant");
  }
};

// Change tab
const changeTab = (_tab: number) => {
  currentTab.value = _tab;
  criteria.value.status = _tab === ParticipantStatusType.All ? undefined : _tab;
  fetchParticipants(1);
};

// Handle search
const handleSearch = async () => {
  if (!searchQuery.value.trim() || !selectedEvent.value) {
    return;
  }

  // Switch to "All" tab when searching
  if (currentTab.value !== ParticipantStatusType.All) {
    headerMenuRef.value?.changeTab(ParticipantStatusType.All);
    currentTab.value = ParticipantStatusType.All;
    criteria.value.status = undefined;
  }

  isLoadingParticipants.value = true;
  try {
    const response = await EventsServices.queryEventPartyUser(
      searchQuery.value.trim(),
      selectedEvent.value.id
    );

    // Map API response to our Participant interface
    if (response.data) {
      participants.value = [response.data].map((item: any) => ({
        id: item.id,
        user: {
          partyId: item.partyId,
          firstName: item.nativeName?.split(" ")[0] || "",
          lastName: item.nativeName?.split(" ").slice(1).join(" ") || "",
          email: item.email,
          avatar: undefined,
        },
        status: item.status,
        createdOn: item.createdOn,
        operatorName: item.lastOperatorName || "",
      }));

      // Clear pagination for search results
      criteria.value = {
        ...criteria.value,
        page: 1,
        pageSize: 25,
        total: 1,
        pageCount: 1,
        hasMore: false,
      };
    } else {
      participants.value = [];
      criteria.value = {
        ...criteria.value,
        page: 1,
        pageSize: 25,
        total: 0,
        pageCount: 0,
        hasMore: false,
      };
    }
  } catch (error) {
    console.error("Error searching participant:", error);
    // If server returns 404 (not found), treat as no results and do not show a toast.
    // For other errors, show an error toast.
    const status = (error as any)?.response?.status;
    if (status !== 404) {
      MsgPrompt.error("Failed to search participant");
    }
    participants.value = [];
  } finally {
    isLoadingParticipants.value = false;
  }
};

// Clear search and show all users (switch to All tab)
const clearSearch = async () => {
  if (!selectedEvent.value) return;

  searchQuery.value = "";

  // Switch to All tab when clearing search
  if (currentTab.value !== ParticipantStatusType.All) {
    headerMenuRef.value?.changeTab(ParticipantStatusType.All);
    currentTab.value = ParticipantStatusType.All;
    criteria.value.status = undefined;
  }

  await fetchParticipants(1);
};

// Fetch participants based on current tab and search
const fetchParticipants = async (page = 1) => {
  if (!selectedEvent.value) return;

  isLoadingParticipants.value = true;
  try {
    criteria.value.page = page;
    criteria.value.eventId = selectedEvent.value.id;
    criteria.value.status =
      currentTab.value === ParticipantStatusType.All
        ? undefined
        : currentTab.value;

    const response = await EventsServices.queryEventUsers(criteria.value);

    // Map API response to our Participant interface
    participants.value = (response.data || []).map((item: any) => ({
      id: item.id,
      user: {
        partyId: item.partyId,
        firstName: item.nativeName?.split(" ")[0] || "",
        lastName: item.nativeName?.split(" ").slice(1).join(" ") || "",
        email: item.email,
        avatar: undefined,
      },
      status: item.status,
      createdOn: item.createdOn,
      operatorName: item.lastOperatorName || "",
    }));

    // Update criteria with response criteria for pagination
    if (response.criteria) {
      criteria.value = {
        ...criteria.value,
        ...response.criteria,
      };
    }
  } catch (error) {
    console.error("Error loading participants:", error);
    MsgPrompt.error("Failed to load participants");
  } finally {
    isLoadingParticipants.value = false;
  }
};

// Select event and load participants
const selectEvent = async (event: Event) => {
  selectedEvent.value = event;
  selectedEventId.value = event.id;
  searchQuery.value = "";
  currentTab.value = ParticipantStatusType.Pending;
  criteria.value.eventId = event.id;
  criteria.value.status = ParticipantStatusType.Pending;
  criteria.value.page = 1;

  // Ensure the visual tab resets to Pending
  headerMenuRef.value?.changeTab(ParticipantStatusType.Pending);

  await fetchParticipants(1);
};

const fetchEvents = async () => {
  isLoading.value = true;
  try {
    const response = await EventsServices.queryEventsList();
    const allEvents = response.data || [];

    // Filter events where key starts with "Event" (same as client side)
    const filteredEvents = allEvents.filter((event: any) => {
      return (
        event.key && event.key.startsWith("Event") && event.key !== "EventShop"
      );
    });

    events.value = filteredEvents.map((event: any) => ({
      id: event.id,
      title: event.title,
      key: event.key,
    }));
  } catch (error) {
    console.error("Error fetching events:", error);
    MsgPrompt.error("Failed to load events");
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchEvents();
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("title.events")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(LoadingRing)
              ]))
            : (!isLoading.value && events.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(NoDataCentralBox)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _createElementVNode("thead", _hoisted_11, [
                      _createElementVNode("tr", _hoisted_12, [
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.title")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (event) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: event.id,
                          class: _normalizeClass(["cursor-pointer event-row", { 'selected-event': event.id === selectedEventId.value }]),
                          onClick: ($event: any) => (selectEvent(event))
                        }, [
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, " (" + _toDisplayString(event.id) + ") " + _toDisplayString(event.title), 1)
                          ])
                        ], 10, _hoisted_14))
                      }), 128))
                    ])
                  ])
                ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("fields.participants")), 1),
          (selectedEvent.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "participantSearchInput",
                      ref: participantSearchInput,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      class: "form-control form-control-solid w-250px ps-5",
                      placeholder: _ctx.$t('fields.user')
                    }, null, 8, _hoisted_25), [
                      [_vModelText, searchQuery.value]
                    ])
                  ]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleSearch,
                    disabled: isLoadingParticipants.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_button, {
                    type: "default",
                    onClick: clearSearch,
                    disabled: isLoadingParticipants.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          (!selectedEvent.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(NoDataCentralBox)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(HeaderMenu, {
                  class: "ms-6",
                  tabs: ParticipantStatusType,
                  onChangeTab: changeTab,
                  ref_key: "headerMenuRef",
                  ref: headerMenuRef
                }, null, 512),
                (isLoadingParticipants.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(LoadingRing)
                    ]))
                  : (participants.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(NoDataCentralBox)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("table", _hoisted_32, [
                          _createElementVNode("thead", _hoisted_33, [
                            _createElementVNode("tr", _hoisted_34, [
                              _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("fields.user")), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
                              _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t("fields.action")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(participants.value, (participant, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_37, [
                                  _createVNode(UserInfo, {
                                    user: participant.user
                                  }, null, 8, ["user"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_el_tag, {
                                    type: getTagType(participant.status),
                                    class: "fs-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`status.${getStatusLabel(participant.status)}`)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(TimeShow, {
                                    "date-iso-string": participant.createdOn
                                  }, null, 8, ["date-iso-string"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(participant.operatorName || "-"), 1),
                                _createElementVNode("td", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getActionButtons(
                            participant
                          ), (button, btnIndex) => {
                                      return (_openBlock(), _createBlock(_component_el_button, {
                                        key: btnIndex,
                                        type: button.type,
                                        size: "small",
                                        onClick: button.action
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(button.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["type", "onClick"]))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(TableFooter, {
                    onPageChange: fetchParticipants,
                    criteria: criteria.value
                  }, null, 8, ["criteria"])
                ])
              ]))
        ])
      ])
    ])
  ]))
}
}

})